import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import MetadataService from '@/api/MetadataService';
import {
  SAVE_FORMS_MUTATION,
  SAVE_GENRES_MUTATION,
  SAVE_ME_MUTATION,
  useStore,
} from '@/store';
import { onBeforeMount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwDefaultTemplate',
  setup(__props) {

const store = useStore();

onBeforeMount(() => {
  if (!store.state.me) {
    console.log('get me');
    MetadataService.me().then((me) => {
      if (me) {
        console.log('got me');
        store.commit(SAVE_ME_MUTATION, { me });
      } else {
        console.log('not found me');
        localStorage.removeItem('accessToken');
      }
    });
  }
  if (!store.state.genres) {
    console.log('get genres');
    MetadataService.genres().then((genres) => {
      if (genres) {
        console.log('got genres');
        store.commit(SAVE_GENRES_MUTATION, { genres });
      }
    });
  }
  if (!store.state.forms) {
    console.log('get forms');
    MetadataService.forms().then((forms) => {
      if (forms) {
        console.log('got forms');
        store.commit(SAVE_FORMS_MUTATION, { forms });
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "app-header"),
    _renderSlot(_ctx.$slots, "main"),
    _renderSlot(_ctx.$slots, "app-footer")
  ], 64))
}
}

})